import { goToUrl } from "../../util/windowLocation";

const ExternalRedirect = ({ url }) => {
  goToUrl(url);
  return null;
};

export default ExternalRedirect;



// WEBPACK FOOTER //
// ./src/components/ExternalRedirect/index.js